import { piniaOfficeOffer } from '@stores/office-offer';
import { createApp } from 'vue';
import OfficeChooser from './OfficeChooser.vue';

export const initOfficeChooser = () => {
  if (!document.getElementById('multioffice-modal-app')) {
    return;
  }

  const app = createApp(OfficeChooser);

  app.config.globalProperties.$companyName = window.COMPANY_NAME;

  app.use(piniaOfficeOffer);
  app.mount('#multioffice-modal-app');
};
